// extracted by mini-css-extract-plugin
export var label = "_bv-5";
export var slideContainer = "_bv-0";
export var slider = "_bv-1";
export var sliderLg = "_bv-4";
export var sliderMd = "_bv-3";
export var sliderSm = "_bv-2";